module.exports = __webpack_public_path__ + "static/Roboto-Bold-subset-534d20237e4198874da8013e4e386aca.woff2";